import React from 'react';
import './Home.css'

import Hero from './Topslider';
import TopService from './TopService';
import StatsCard from './StatsCard';
import LastestNews from './LatestNews';
import Blogs from './Blogs';
import AchievementSlider from './AchievementSlider';
import Products from './Products';
import ClientsSection from './clients-section';
import DependenceiesSlider from './dependencies-slider';
import CustomerTestimonials from '../Customer/customer-testimonials';

const Home = () => {
  console.log('Updated to test')
  return (
    <main className='home'>
      <Hero />

      <div className="container">
        <TopService />
        <Products />
      </div>

      <StatsCard />
      <AchievementSlider />

      {/* الاعتمادات */}
      <div className="container">
        <DependenceiesSlider />
      </div>

      <div className="container">
        <ClientsSection />
      </div>
      <div className="container">
        <LastestNews />
        <Blogs />
        {/* <CustomerTestimonials/> */}
      </div>
    </main>
  );
};

export default Home;